export default "__VITE_ASSET__fIVfEmFi__"